class VideoControls {
    constructor(videoElement) {
        this.videoElement = videoElement;
        this.audioButton = this.videoElement
            .nextElementSibling;
        this.mutedIcon = this.getMutedIcon();
        this.enabledIcon = this.getEnabledIcon();
        this.addEventListeners();
    }
    addEventListeners() {
        this.audioButton.addEventListener("click", this.handleAudioControlClick.bind(this));
    }
    handleAudioControlClick({ target }) {
        if (target.dataset.state === "0")
            this.unMute();
        if (target.dataset.state === "1")
            this.mute();
    }
    getMutedIcon() {
        return this.audioButton.querySelector(".fa-volume-xmark");
    }
    getEnabledIcon() {
        return this.audioButton.querySelector(".fa-volume-high");
    }
    mute() {
        this.mutedIcon.classList.remove("d-none");
        this.enabledIcon.classList.add("d-none");
        this.videoElement.muted = true;
    }
    unMute() {
        this.enabledIcon.classList.remove("d-none");
        this.mutedIcon.classList.add("d-none");
        this.videoElement.muted = false;
    }
}
export const initAudioControls = () => document
    .querySelectorAll("#oimVideoHeader")
    .forEach((control) => new VideoControls(control));
